import { Matrix, Point } from '@printu/geom';
import { PathFitter } from 'app/core/graphics/Fitter';
import { Path } from 'app/core/graphics/Path';
import { ProjectActions } from 'app/stores/project/actions';
import { getInsertStyle } from 'app/stores/selectors';
export const InsertPathBased = (markerFactory) => (dispatch, getState) => {
    const state = getState();
    const { size, color, sizeFactor, viewportZoom: zoom, } = getInsertStyle(state);
    const points = [];
    const onDragStart = (payload, point) => {
        var _a, _b;
        const marker = markerFactory(point);
        payload.itemId = marker.id;
        const markerSize = (_a = marker.size) !== null && _a !== void 0 ? _a : size;
        marker.size = markerSize / sizeFactor;
        const markerColor = (_b = marker.color) !== null && _b !== void 0 ? _b : color;
        marker.color = markerColor;
        dispatch(ProjectActions.itemInsert({
            marker,
            undoable: true,
        }));
    };
    const onDrag = (payload, point) => {
        const { itemId: id, down } = payload;
        if (id) {
            const vec = new Point(point.x - down.x, point.y - down.y);
            const lastPoint = points[points.length - 1];
            if (lastPoint) {
                const distance = vec.getDistance(lastPoint, true);
                const threshold = 25 + Math.max(1, size) / 3 /* MarkerSize.s1 */;
                const thresholdInImageSpace = threshold / sizeFactor / zoom;
                if (distance < thresholdInImageSpace) {
                    return;
                }
            }
            points.push(vec);
            dispatch(ProjectActions.itemUpdate({
                id,
                patch: {
                    bbox: {
                        x: 0,
                        y: 0,
                        width: 100,
                        height: 100,
                    },
                    data: points.reduce((data, lPoint) => `${data} L ${lPoint.x} ${lPoint.y}`, 'm 0 0'),
                },
                undoable: false,
            }));
        }
    };
    const onDragEnd = (payload, _point) => {
        const { itemId: id } = payload;
        if (!id) {
            return;
        }
        let markerIsValid = false;
        if (points.length > 3) {
            const { down } = payload;
            const fitter = new PathFitter(points);
            const segments = fitter.fit(2.5);
            if (segments && segments.length) {
                // translate path to always have it relative top-left bbox corner
                const pObj = new Path(segments);
                let bbox = pObj.bbox();
                const x = down.x - bbox.x.min;
                const y = down.y - bbox.y.min;
                pObj.transform(Matrix.translate(bbox.x.min, bbox.y.min));
                bbox = pObj.bbox();
                const data = pObj.getPathData();
                dispatch(ProjectActions.itemUpdate({
                    id,
                    patch: {
                        x,
                        y,
                        bbox: {
                            x: bbox.x.min,
                            y: bbox.y.min,
                            width: Math.abs(bbox.x.max - bbox.x.min),
                            height: Math.abs(bbox.y.max - bbox.y.min),
                        },
                        data,
                        segments: pObj.toArray(),
                    },
                    undoable: false,
                }));
                markerIsValid = true;
            }
        }
        if (!markerIsValid) {
            dispatch(ProjectActions.deleteItems({ ids: [id], undoable: false }));
        }
        points.splice(0, points.length);
    };
    const onEnd = payload => {
        onDragEnd(payload, null);
    };
    return {
        onPointerDown: onDragStart,
        onPointerDrag: onDrag,
        onPointerUp: onDragEnd,
        onEnd,
        payload: { path: points },
    };
};
